module.exports = __webpack_public_path__ + "img/IMG_1899_L_WoodMatted.b7ed8e98.jpg";